import { AbilityBuilder, Ability } from '@casl/ability';
import { User } from '../../../types/interfaces';

export function defineAbilitiesFor(user: User) {
  const { can, build } = new AbilityBuilder(Ability);

  if (user.permissions) {
    Object.entries(user.permissions).forEach(([resource, actions]: any) => {
      actions.forEach((action: string) => {
        can(action, resource);
      });
    });
  }
  // Раздел «Аналитика» нужен двум ролям с непересекающимися правами (ТП —
  // активность, маркетинг — сценарии и баллы). Маршрут и пункт меню умеют
  // проверять одно право, поэтому выводим из них общее view/analytics.
  const permissions = (user.permissions ?? {}) as unknown as Record<string, string[]>;
  if (['analyticssession', 'scenario', 'userpoints'].some((model) => permissions[model]?.includes('view'))) {
    can('view', 'analytics');
  }
  if (user.is_superuser) {
    can('manage', 'all');
  }

  return build();
}
